import {
  BarChartOutlined,
  BuildOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  InboxOutlined,
  NotificationOutlined,
  PushpinOutlined,
  SettingOutlined,
  ShopOutlined,
  TeamOutlined,
  ControlOutlined,
  ExperimentOutlined,
  CheckSquareOutlined,
  FundProjectionScreenOutlined,
} from '@ant-design/icons';
import NotFound from 'containers/404';
import AccountSettings from 'containers/AccountSettings';
import Subscription from 'containers/AccountSettings/Subscription';
import UserManagement from 'containers/AccountSettings/UserManagement';
import OrganizationSettings from 'containers/OrganizationSettings';
import Login from 'containers/auth';
import ForgetPasswordConfirm from 'containers/auth/ForgetPasswordConfirm';
import Onboarding from 'containers/auth/Onboarding';
import ForgetPassword from 'containers/auth/ResetPassword';
import SignUp from 'containers/auth/SignUp';
import CouponsForm from 'containers/CouponForm';
import Coupons from 'containers/Coupons';
import CompanyDetail from 'containers/CompanyDetails';
import CustomerDetail from 'containers/CustomerDetails';
import Customers from 'containers/Customers';
import Dashboard from 'containers/Dashboard';
import EditAddress from 'containers/EditAddress';
import GlobalMenus from 'containers/GlobalMenuManagement/GlobalMenus';
import Location from 'containers/Location';
import Marketing from 'containers/Marketing';
import MarketingDetail from 'containers/MarketingDetail';
import MarketingForm from 'containers/MarketingForm';
import Flows from 'containers/Flows';
import FlowBuilder from 'containers/FlowBuilder';
import PrepKitchen from 'containers/PrepKitchen';
import Segments from 'containers/Segments';
import SegmentDetail from 'containers/Segments/SegmentDetail';
import Campaigns from 'containers/Campaigns';
import CampaignForm from 'containers/Campaigns/CampaignForm';
import CampaignDetail from 'containers/Campaigns/CampaignDetail';
import MenuManagementContainer from 'containers/MenuManagement/MenuManagemntContainer';
import MerchantCreateFrom from 'containers/MerchantCreateForm';
import MerchantDetail from 'containers/MerchantDetail';
import PosHubConsole from 'containers/PosHubConsole';
import MerchantEditFrom from 'containers/MerchantEditForm';
import Merchants from 'containers/Merchants';
import DirectEntry from 'containers/Order/CreateOrder';
import EditingOrder from 'containers/Order/EditOrder';
import OrdersTab from 'containers/Order/ListOrders';
import Reports from 'containers/Reports';
import Support from 'containers/Support';
import PlatformClientsList from 'containers/Platform/Clients/List';
import PlatformClientCreate from 'containers/Platform/Clients/Create';
import PlatformClientDetail from 'containers/Platform/Clients/Detail';
import PlatformReporting from 'containers/Platform/Reporting/Overview';
import RequireSuperuser from 'components/RequireSuperuser';
import Tasks from 'containers/Tasks';
import Pipelines from 'containers/Pipelines';
import React from 'react';
import { PERMISSIONS } from './permissions';
import { SIDEBAR_ITEMS } from './sidebar-items';
import { CONSOLE_PLATFORM_SWITCH } from './platform-sidebar-items';

function withSuperuser(Component) {
  return function SuperuserGuardedRoute(props) {
    return (
      <RequireSuperuser>
        <Component {...props} />
      </RequireSuperuser>
    );
  };
}

export const MainRoutes = {
  LOGIN: {
    path: '/login',
    component: Login,
  },
  SIGNUP: {
    path: '/sign-up',
    component: SignUp,
  },
  DASHBOARD: {
    path: '/console',
    component: Dashboard,
  },
  PLATFORM_CLIENTS: {
    path: '/platform/clients',
    component: withSuperuser(PlatformClientsList),
  },
  PLATFORM_CLIENT_NEW: {
    path: '/platform/clients/new',
    component: withSuperuser(PlatformClientCreate),
  },
  PLATFORM_CLIENT_DETAIL: {
    path: '/platform/clients/:id',
    component: withSuperuser(PlatformClientDetail),
  },
  PLATFORM_REPORTING: {
    path: '/platform/reporting',
    component: withSuperuser(PlatformReporting),
  },
  FORGET_PASSWORD: {
    path: '/forget-password',
    component: ForgetPassword,
  },
  CUSTOMER_ADDRESS_EDIT: {
    path: '/console/customer-address/:id/:addressId',
    component: EditAddress,
  },
  CONTACTS: {
    path: '/console/customers',
    component: Customers,
  },
  // CUSTOMERS: {
  //   path: '/console/customers/:id',
  //   component: CustomerDetail,
  // },
  LOCATIONS: {
    path: '/console/locations/*',
    component: Location,
  },
  MERCHANTS: {
    path: '/console/restaurants',
    component: Merchants,
  },
  ACCOUNT_SETTINGS: {
    path: '/console/setting',
    component: AccountSettings,
  },
  COUPONS: {
    path: '/console/coupons',
    component: Coupons,
  },
  DIRECT_ENTRY: {
    path: '/console/orders/direct-entry',
    component: DirectEntry,
  },
  ORDERS: {
    path: '/console/orders/:orderId?',
    component: OrdersTab,
  },
  REPORTS: {
    path: '/console/reports/*',
    component: Reports,
  },
  SUPPORT: {
    path: '/console/support',
    component: Support,
  },
  MARKETING: {
    path: '/console/marketing',
    component: Marketing,
  },
  CAMPAIGNS: {
    path: '/console/marketing/campaigns',
    component: Campaigns,
  },
  SEGMENTS: {
    path: '/console/segments',
    component: Segments,
  },
  GLOBAL_MENUS: {
    path: '/console/menus/*',
    component: GlobalMenus,
  },
  PREP_KITCHEN: {
    path: '/console/prep-kitchen/*',
    component: PrepKitchen,
  },
  ORGANIZATION_SETTINGS: {
    path: '/console/organization-settings',
    component: OrganizationSettings,
  },
  TASKS: {
    path: '/console/tasks',
    component: Tasks,
  },
  PIPELINE: {
    path: '/console/pipeline',
    component: Pipelines,
  },
};

// TODO: this routes should be move into nested level on their parents
export const INNER_ROUTES = [
  {
    path: '/onboarding',
    component: Onboarding,
  },
  {
    path: '/redirect/api/user/rest-auth/password/reset/confirm/:uid/:token/',
    component: ForgetPasswordConfirm,
  },
  {
    path: '/redirect/api/v1/user/rest-auth/password/reset/confirm/:uid/:token/',
    component: ForgetPasswordConfirm,
  },
  {
    path: '/console/customers/companies/:id/*',
    component: CompanyDetail,
  },
  {
    path: '/console/customers/:id/*',
    component: CustomerDetail,
  },
  {
    path: '/console/marketing/create',
    component: MarketingForm,
  },
  {
    path: '/console/marketing/edit/:id',
    component: MarketingForm,
  },
  {
    path: '/console/restaurants/edit/:id',
    component: MerchantEditFrom,
  },
  {
    path: '/console/restaurants/:id',
    component: MerchantDetail,
  },
  {
    path: '/console/restaurants/create',
    component: MerchantCreateFrom,
  },
  {
    path: '/console/restaurants/:id/menus/*',
    component: MenuManagementContainer,
  },
  {
    path: '/console/restaurants/:id/pos/:tab',
    component: PosHubConsole,
  },
  {
    path: '/console/restaurants/:id/pos',
    component: PosHubConsole,
  },
  {
    path: '/console/marketing/duplicate/:id',
    component: MarketingForm,
  },
  {
    path: '/console/marketing/detail/:id',
    component: MarketingDetail,
  },
  {
    path: '/console/marketing/flows',
    component: Flows,
  },
  {
    path: '/console/marketing/flows/create',
    component: FlowBuilder,
  },
  {
    path: '/console/marketing/flows/edit/:id',
    component: FlowBuilder,
  },
  {
    path: '/console/marketing/campaigns/create',
    component: CampaignForm,
  },
  {
    path: '/console/marketing/campaigns/:id/edit',
    component: CampaignForm,
  },
  {
    path: '/console/marketing/campaigns/:id',
    component: CampaignDetail,
  },
  {
    path: '/console/marketing/campaigns',
    component: Campaigns,
  },
  {
    path: '/console/orders/:id/edit',
    component: EditingOrder,
  },
  {
    path: '/console/coupons/form',
    component: CouponsForm,
  },
  {
    path: '/console/coupons/form/:id',
    component: CouponsForm,
  },
  {
    path: '/console/segments/:id',
    component: SegmentDetail,
  },

  {
    path: '/console/user-management',
    component: UserManagement,
  },

  {
    path: '/console/setting/subscription',
    component: Subscription,
  },
  {
    path: '/',
    component: Dashboard,
  },
  {
    path: '*',
    component: NotFound,
  },
];

const resizeIcon = (Icon) => <Icon style={{ fontSize: '16px' }} />;

// to prevent dep-cycle the sidebar-items is populated indirectly
if (SIDEBAR_ITEMS.length === 0) {
  SIDEBAR_ITEMS.push(...[
    {
      route: MainRoutes.DASHBOARD,
      icon: resizeIcon(DashboardOutlined),
      label: 'Dashboard',
    },
    {
      route: {
        path: '/console/orders',
        component: OrdersTab,
      },
      label: 'Orders',
      permissions: [PERMISSIONS.ORDERS],
      icon: resizeIcon(InboxOutlined),
      badge: 'orders',
      action: {
        route: MainRoutes.DIRECT_ENTRY.path,
        label: 'Create Order',
      },
    },
    {
      route: MainRoutes.CONTACTS,
      permissions: [PERMISSIONS.CUSTOMERS],
      label: 'Customers',
      icon: resizeIcon(TeamOutlined),
      action: {
        route: MainRoutes.CONTACTS.path,
        label: 'Add Customer',
        state: { openAddCustomer: true },
      },
    },
    {
      route: MainRoutes.TASKS,
      label: 'Tasks',
      icon: resizeIcon(CheckSquareOutlined),
    },
    {
      route: MainRoutes.PIPELINE,
      label: 'Pipeline',
      permissions: [PERMISSIONS.CUSTOMERS],
      icon: resizeIcon(FundProjectionScreenOutlined),
    },
    {
      route: MainRoutes.MERCHANTS,
      permissions: [PERMISSIONS.MERCHANTS],
      label: 'Restaurants',
      icon: resizeIcon(ShopOutlined),
      action: {
        route: '/console/restaurants/create',
        label: 'Create restaurant',
      },
    },
    {
      route: MainRoutes.PREP_KITCHEN,
      permissions: [PERMISSIONS.GLOBAL_MENU],
      label: 'Prep & Kitchen',
      icon: resizeIcon(ExperimentOutlined),
      subMenus: [
        {
          route: {
            path: '/console/prep-kitchen/ingredients',
            component: PrepKitchen,
          },
          permissions: [PERMISSIONS.GLOBAL_MENU],
          label: 'Ingredients',
        },
        {
          route: {
            path: '/console/prep-kitchen/pull-sheet',
            component: PrepKitchen,
          },
          permissions: [PERMISSIONS.GLOBAL_MENU],
          label: 'Pull Sheets',
        },
        {
          route: {
            path: '/console/prep-kitchen/prep-sheet',
            component: PrepKitchen,
          },
          permissions: [PERMISSIONS.GLOBAL_MENU],
          label: 'Prep Sheets',
        },
        {
          route: {
            path: '/console/prep-kitchen/handoff-sheets',
            component: PrepKitchen,
          },
          permissions: [PERMISSIONS.GLOBAL_MENU],
          label: 'Handoff Sheets',
        },
      ],
    },
    {
      route: {
        path: '/console/menus',
        component: GlobalMenus,
      },
      permissions: [PERMISSIONS.GLOBAL_MENU],
      label: 'Global menus',
      icon: resizeIcon(BuildOutlined),
      action: {
        route: '/console/menus/create',
        label: 'Create menu',
      },
    },
    {
      route: {
        path: '/console/locations',
        component: Location,
      },
      permissions: [PERMISSIONS.PARENTS],
      label: 'Locations',
      icon: resizeIcon(PushpinOutlined),
    },
    {
      route: MainRoutes.ORGANIZATION_SETTINGS,
      label: 'Settings',
      icon: resizeIcon(ControlOutlined),
      permissions: [PERMISSIONS.ADMIN_ACCESS],
    },
    {
      route: {
        path: '/console/reports',
        component: Reports,
      },
      permissions: [PERMISSIONS.REPORTS],
      label: 'Reports',
      icon: resizeIcon(BarChartOutlined),
    },
    {
      route: MainRoutes.MARKETING,
      permissions: [PERMISSIONS.MARKETING, PERMISSIONS.COUPONS],
      label: 'Marketing',
      icon: resizeIcon(NotificationOutlined),
      subMenus: [
        {
          route: MainRoutes.MARKETING,
          permissions: [PERMISSIONS.MARKETING],
          label: 'Push Notifications',
        },
        {
          route: MainRoutes.CAMPAIGNS,
          permissions: [PERMISSIONS.MARKETING],
          label: 'Campaigns',
        },
        {
          route: {
            path: '/console/marketing/flows',
            component: Flows,
          },
          permissions: [PERMISSIONS.MARKETING],
          label: 'Flows',
        },
        {
          route: MainRoutes.SEGMENTS,
          permissions: [PERMISSIONS.MARKETING],
          label: 'Segments',
        },
        {
          route: MainRoutes.COUPONS,
          permissions: [PERMISSIONS.COUPONS],
          label: 'Coupons',
        },
      ],
    },
    {
      route: MainRoutes.SUPPORT,
      label: 'Help center',
      icon: resizeIcon(CustomerServiceOutlined),
      permissions: [PERMISSIONS.ADMIN_ACCESS],
      bottom: true,
      onClick: () => window.open('https://dlivrdio.atlassian.net/servicedesk/customer/portal/67', '_blank', 'noopener,noreferrer'),
    },
    {
      route: MainRoutes.ACCOUNT_SETTINGS,
      label: 'Account settings',
      icon: resizeIcon(SettingOutlined),
      bottom: true,
    },
    {
      ...CONSOLE_PLATFORM_SWITCH,
    },
  ]);
}
